export * from './checkUserIdentifer.util';
export * from './mapKeyValueToObject.util';
export * from './tenancyFeatureChecker';

export function isNotNullOrUndefined<T>(
  input: null | undefined | T
): input is T {
  return input !== null && input !== undefined;
}
